var React = require('react');

function Leaf48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M39.414 30.314c-4.793 5.183-11.425 7.811-19.709 7.811-3.852 0-8.118-.584-12.678-1.72-4.419 6.541-5.036 10.772-5.048 10.861a1 1 0 0 1-1.11.871A1 1 0 0 1 0 47.025c.047-.403.739-5.355 5.98-12.757-.099-4.061.242-17.556 8.431-26.414C21.473.219 32.552-1.851 47.048 1.818a1 1 0 0 1 .751.898c.052.703 1.142 17.294-8.385 27.598zm6.427-26.731C32.46.349 22.302 2.264 15.872 9.219c-6.32 6.836-7.633 16.949-7.856 22.355 1.887-2.359 4.221-4.911 7.095-7.605a.986.986 0 0 1 .419-.39 99.005 99.005 0 0 1 7.397-6.184v-6.943a1 1 0 0 1 .997-1.003 1 1 0 0 1 .997 1.003v5.463c4.358-3.166 9.467-6.434 15.476-9.736a.99.99 0 0 1 1.352.397 1.005 1.005 0 0 1-.396 1.361C31.58 13.308 24.238 18.6 18.7 23.481h14.198c.551 0 .997.448.997 1.002a1 1 0 0 1-.997 1.003H16.495c-3.516 3.317-6.19 6.407-8.218 9.159 4.112.974 7.954 1.476 11.428 1.476 7.705 0 13.841-2.41 18.242-7.163 7.859-8.492 7.985-22.106 7.894-25.375z","key":1})]);
}

Leaf48px.displayName = "Leaf48px";

Leaf48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.85 48.1"};

module.exports = Leaf48px;

Leaf48px.default = Leaf48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/leaf-48px.svg
// module id = 1145
// module chunks = 0